import { createAxiosClient } from "@ntg/component-library/utilities";
import { useQuery } from "@tanstack/react-query";
import { IServiceOrderLineCS } from "../../declarations/ServiceOrderLineCS";

const getServiceOrderLinesCS = async (
    serviceOrderID: number,
): Promise<IServiceOrderLineCS[]> => {
    const axiosAuth = createAxiosClient("D365FO");
    const response = await axiosAuth.get<IServiceOrderLineCS[]>(
        `/ServiceOrder/GetServiceOrderLinesCS/${serviceOrderID}`,
    );
    return response.data;
};

export const useGetServiceOrderLinesCS = (serviceOrderID: number) =>
    useQuery<IServiceOrderLineCS[]>({
        enabled: serviceOrderID > 0,
        queryFn: () => getServiceOrderLinesCS(serviceOrderID),
        queryKey: ["GetServiceOrderLinesCS", serviceOrderID],
        refetchOnWindowFocus: false,
        retry: false,
    });
